import ArrowDashed from '@/assets/icons/arrow-dashed-primary.svg'
import { cn } from '@/core/lib/utils/cn'
import { Link } from '@/i18n/navigation'

type Props = {
  steps: {
    label: React.ReactNode
    icon: React.ReactNode
    link: string
  }[]
  activeStep: number
  canProceed?: boolean
  canBack?: boolean
  alignSteps?: 'start' | 'center' | 'end'
}

const stepsAlign = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
}

export const Stepper: React.FC<Props> = ({
  steps,
  activeStep,
  canProceed,
  canBack,
  alignSteps = 'start',
}) => {
  return (
    <div
      className={cn(
        'mb-4 flex w-full items-start overflow-x-auto',
        stepsAlign[alignSteps],
      )}
    >
      {steps.map((step, index) => {
        const isDisabled =
          (!canProceed && index > activeStep) ||
          (!canBack && index < activeStep)
        return (
          <div key={index} className='flex items-baseline min-[28rem]:gap-2'>
            <Link
              href={step.link}
              key={index}
              className={cn(
                'flex-1',
                isDisabled
                  ? 'pointer-events-auto cursor-not-allowed'
                  : 'cursor-pointer',
              )}
              onClick={e => {
                if (isDisabled) {
                  e.preventDefault()
                }
              }}
              aria-disabled={!(isDisabled || index === activeStep)}
            >
              <span
                className={cn(
                  'mx-auto flex h-8 w-8 items-center justify-center rounded-full p-2 text-lg transition-colors duration-150 min-[28rem]:h-10 min-[28rem]:w-10',
                  index <= activeStep
                    ? 'bg-navy text-white'
                    : 'bg-grey-5 text-navy',
                )}
              >
                {step.icon}
              </span>

              <div className='text-navy mt-2 text-center text-sm text-wrap min-[28rem]:text-base'>
                {step.label}
              </div>
            </Link>
            {index < steps.length - 1 && (
              <span className='mb-7 w-8 px-0 sm:w-16 sm:px-3'>
                <ArrowDashed className='h-full w-full' />
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
